import {eatalianoAxios} from "@/data/api/http/axios";
import {ProductReference} from "@/data/entities/product";

export const listProducts = (restaurantId: number): Promise<ProductReference[]> => (
    eatalianoAxios
        .get(`/restaurant/${restaurantId}/products`)
        .then(response => response.data)
);